<!-- Add this in your component's HTML template where you want the spinner -->
<mat-spinner *ngIf="isLoading" diameter="50" color="primary"></mat-spinner>
